<template>
  <div id="forms_overview__wrapper" class="pa-5">
    <v-row class="mb-8 mb-md-0">
      <v-col cols="12" md="4">
        <v-btn to="/forms/builder" class="custom primary w-100 py-5">
          Formular Editor
        </v-btn>
      </v-col>
      <v-col cols="12" md="4">
        <v-btn to="/forms/submissions" class="custom primary w-100 py-5">
          Eingereichte Formulare
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "FormOverview",
  async mounted() {
    if (!(this.isFormEditor || this.isFormSubmissionEditor)) {
      return await this.$router.push(`/forms/`);
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    isFormEditor() {
      return (
        this.isAdmin || this.currentUser?.scopes.includes("role:form_editor")
      );
    },
    isFormSubmissionEditor() {
      return (
        this.isAdmin ||
        this.currentUser?.scopes.includes("role:submission_read")
      );
    }
  }
};
</script>
